import * as React from 'react';
import { Container, Grid, GridColumn, Image, Logo, Separator, Text } from 'telia-front-react';
import ErrorUtil from '../util/ErrorUtil';

interface PageErrorBoundaryProps {
  app?: App;
  children?: React.ReactNode;
}
class PageErrorBoundary extends React.Component<PageErrorBoundaryProps> {
  phoneIconDiil =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU2IDQzLjE3MiA0Ny44MjggMzVhNC4wOTUgNC4wOTUgMCAwIDAtNS42NTYgMGwtMy43NTcgMy43NTdhMi4wMDIgMi4wMDIgMCAwIDEtMi44MyAwTDI1LjI0MiAyOC40MTRhMiAyIDAgMCAxIC4wMDEtMi44MjdMMjkgMjEuODI4YTQuMDA1IDQuMDA1IDAgMCAwIDAtNS42NTZMMjAuODI4IDhhNC4wOTUgNC4wOTUgMCAwIDAtNS42NTYgMGwtMy4yNzMgMy4yNzNhMTguMDIgMTguMDIgMCAwIDAgMCAyNS40NTRsMTUuMzczIDE1LjM3NGExOC4wMiAxOC4wMiAwIDAgMCAyNS40NTUgMEw1NiA0OC44MjhhNC4wMDUgNC4wMDUgMCAwIDAgMC01LjY1NlptLTYuMSA2LjFhMTQuMDE1IDE0LjAxNSAwIDAgMS0xOS44IDBMMTQuNzI4IDMzLjlhMTQuMDE2IDE0LjAxNiAwIDAgMSAwLTE5LjhMMTggMTAuODI5IDI2LjE3MiAxOWwtMy43NTcgMy43NTdhNS45OTkgNS45OTkgMCAwIDAgMCA4LjQ4NWwxMC4zNDMgMTAuMzQ1YTYuMDEgNi4wMSAwIDAgMCA4LjQ4NS0uMDAxTDQ1IDM3LjgyOCA1My4xNzIgNDZsLTMuMjczIDMuMjczWiIvPjwvc3ZnPg==';

  phoneIconSuper =
    'data:image/svg+xml;base64,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';

  public state = {
    hasError: false,
    otelReference: ''
  };

  public componentDidCatch(error: Error | null) {
    const otelReference = ErrorUtil.pushError(true, error);
    this.setState({ hasError: true, otelReference });
  }

  public render() {
    const { app } = this.props;
    const phoneIcon = app === 'diil' ? this.phoneIconDiil : this.phoneIconSuper;

    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Container>
        <Separator spacing="small" color="invisible" className={'hidden-lg hidden-xl'} />
        <Separator spacing="large" color="invisible" className={'hidden-xs hidden-sm hidden-md'} />
        <Logo brand={app} text={app === 'diil' ? 'Diil' : 'Super'} size={'small'} />
        <Separator spacing="medium-plus" color="invisible" className={'hidden-xs hidden-sm hidden-md'} />
        <Separator spacing="xsmall" color="invisible" className={'hidden-lg hidden-xl'} />
        <Grid align={['center-lg']} gutter={'none'} reverse={['lg']}>
          <GridColumn width={['min-xs', 'lg-6']}>
            <Image
              className="hidden-lg hidden-xl"
              align="left"
              role="presentation"
              width={144}
              srcset={`https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_288/icons/Help_Center_${
                app === 'diil' ? 'Diil' : 'Super'
              }.svg`}
              sources={[
                {
                  srcset: `https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_576/icons/Help_Center_${
                    app === 'diil' ? 'Diil' : 'Super'
                  }.svg`,
                  minWidth: '144px'
                }
              ]}
            />

            <Image
              className="hidden-md hidden-xs hidden-sm"
              align="center"
              role="presentation"
              width={288}
              srcset={`https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_576/icons/Help_Center_${
                app === 'diil' ? 'Diil' : 'Super'
              }.svg`}
              sources={[
                {
                  srcset: `https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1152/icons/Help_Center_${
                    app === 'diil' ? 'Diil' : 'Super'
                  }.svg`,
                  minWidth: '288px'
                }
              ]}
            />
            <Separator spacing="small" color="invisible" className={'hidden-lg hidden-xl'} />
          </GridColumn>
          <GridColumn width={['lg-6']}>
            <Text>
              <h1 className={app === 'diil' ? '' : 'c-brand-primary-text'}>Vabandame, tekkis tehniline viga</h1>
              <p className={'text-break h4'}>
                <strong>{this.state.otelReference}</strong>
              </p>
              <p className="h4">Seni saad meiega ühendust klienditeeninduse numbril.</p>
              <p className={'text__margin-half h4'}>
                <img width="24" height="24" alt="Phone" style={{ verticalAlign: 'text-bottom' }} src={phoneIcon} /> Eraklient &ndash; 123
              </p>
              <p className={'text__margin-half h4'}>
                <img width="24" height="24" alt="Phone" style={{ verticalAlign: 'text-bottom' }} src={phoneIcon} /> Äriklient &ndash; 1551
              </p>
            </Text>
          </GridColumn>
        </Grid>
        <Separator spacing="small" color="invisible" className={'hidden-xs hidden-sm hidden-md'} />
        <Separator spacing="medium" className={'hidden-lg hidden-xl'} />
        <Grid align={['center-md']} gutter={'none'} horizontalGutter={'medium'}>
          <GridColumn width={['lg-6']}>
            <Text>
              <h2 className="h4">
                <strong>Подождите немного!</strong>
              </h2>
              <p className="h5">Мы проводим техническое обслуживание сайта, и скоро все снова заработает как надо.</p>
              <p className="h5">До этого с нами можно связаться по номерам службы поддержки 123 (частный клиент) или 1551 (бизнес-клиент).</p>
              <p className="h5">Спасибо за терпение!</p>
            </Text>
            <Separator spacing="medium" className={'hidden-lg hidden-xl'} />
          </GridColumn>
          <GridColumn width={['lg-6']} border={['left-lg']}>
            <Text>
              <h2 className="h4">
                <strong>You have to wait a bit.</strong>
              </h2>
              <p className="h5">We are doing maintenance work on the website, but soon everything will be working like clockwork again.</p>
              <p className="h5">In the meantime, you can contact us by calling 123 (private customers) or 1551 (business customers).</p>
              <p className="h5">Thank you for your patience!</p>
            </Text>
          </GridColumn>
        </Grid>
      </Container>
    );
  }
}

export default PageErrorBoundary;
